import type { FC } from 'react';

import styles from './EmailSignaturePreviewBox.module.scss';

interface PreviewBoxContainer {
  isLite?: boolean;
}

const PreviewBoxContainer: FC<React.PropsWithChildren<PreviewBoxContainer>> = ({ children, isLite }) => {
  return (
    <div className={styles['em-sig-preview-box']} data-is-lite={isLite}>
      {children}
    </div>
  );
};

const PreviewBoxTopSectionContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['em-sig-preview-top-section']}>{children}</div>;
};

const PreviewBoxHeaderSection: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['em-sig-preview-box-header']}>{children}</div>;
};

const PreviewBoxHeaderDotsContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['em-sig-preview-box-header-dots-container']}>{children}</div>;
};

const PreviewBoxHeaderDot: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['em-sig-preview-box-header-dot']}>{children}</div>;
};

const PreviewBoxHeader: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <PreviewBoxHeaderSection>
      <PreviewBoxHeaderDotsContainer>
        <PreviewBoxHeaderDot />
        <PreviewBoxHeaderDot />
        <PreviewBoxHeaderDot />
      </PreviewBoxHeaderDotsContainer>
    </PreviewBoxHeaderSection>
  );
};

const EmailSignaturePreviewBox: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <PreviewBoxContainer>
      <PreviewBoxTopSectionContainer>
        <PreviewBoxHeader />
        <div className={styles['em-sig-preview-box-dummy-body']}>
          <div className={styles['em-sig-to-dummy-row']}>
            To: <span className={styles['em-sig-dummy-bubble']}>Recipient email</span>
          </div>
          <div className={styles['em-sig-to-dummy-row']}>
            Subject: <span className={styles['em-sig-dummy-bubble']}>Check out my new email signature!</span>
          </div>
        </div>
      </PreviewBoxTopSectionContainer>

      {children}
    </PreviewBoxContainer>
  );
};

const EmailSignaturePreviewBoxLite: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <PreviewBoxContainer isLite={true}>
      <PreviewBoxTopSectionContainer>
        <PreviewBoxHeader />
      </PreviewBoxTopSectionContainer>

      <div className={styles['lite-body-content']}>{children}</div>
    </PreviewBoxContainer>
  );
};

export default EmailSignaturePreviewBox;

export { EmailSignaturePreviewBoxLite };
